type ObjectOrArray = Record<string | number, unknown> | unknown[];

/**
 * Searches for the presence of { key: value } pair in a potentially deeply-nested object/Array.
 * The maxDepth parameter helps prevent infinitely-deep traversals.
 */
export function hasKeyValuePair(
  obj: ObjectOrArray,
  [key, value]: [string | number, unknown],
  maxDepth = 5
) {
  if (maxDepth <= 0) return false;

  // Check all keys in this object/array
  for (const k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k)) {
      if (k === key && obj[k] === value) {
        // Key-value pair has been found!
        return true;
      }

      const val = obj[k];
      const isObject = typeof val === "object";
      const isArray = Array.isArray(val);

      if ((isObject || isArray) && val != null) {
        // Search one level deeper...
        if (hasKeyValuePair(val as ObjectOrArray, [key, value], maxDepth - 1)) {
          return true;
        }
      }
    }
  }

  return false;
}
